import appClient from './appClient'

export const submitOrder = async (orderData) => {
    console.log('API submitOrder orderData:', orderData);

    try {
        // Выполняем запрос к серверу
        const response = await appClient.post(`/order/create`, orderData);

        // Логируем успешный результат
        console.info('Order submitted successfully:', response.data);

        return response.data.orderId; // Возвращаем результат для дальнейшей обработки
    } catch (error) {
        // Логируем ошибку
        console.error('Error submitting order:', error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error('Failed to submit order.');
    }
};

//TODO move to productAPI
export const updProductStatus = async (productIds, status) => {
    console.log('API updProductStatus productIds:', productIds, 'status:', status);

    try {
        // Выполняем запрос к серверу
        const response = await appClient.patch(`/product/update-status`, {
            productIds,
            status,
        });

        // Логируем успешный результат
        console.info('Product statuses updated successfully:', response.data);

        return response.data;
    } catch (error) {
        // Логируем ошибку
        console.error('Error updating product statuses:', error);

        // Выбрасываем ошибку для обработки в вызывающем коде
        throw new Error('Failed to update product statuses.');
    }
};
export const updatePaymentStatus = async (orderId, status) => {
    console.log('api updatePaymentStatus orderId:', orderId, 'status:', status);
    //const response = await axios.post(`/update-payment-status`, { orderId, status });
    //return response.data;
    return true;
}